export const colors = {
  /**'#2c2321' */
  black2: '#2c2321',
  /** '#191919' */
  black: '#191919',
  /** '#808080' */
  darkGray: '#808080',
  /** '#aaaaaa' */
  gray: '#aaaaaa',
  /** '#dbdbdb' */
  lightGrey: '#dbdbdb',
  /** '#ededed' */
  lighterGray: '#ededed',
  /** '#cbcbcb' */
  borderGray: '#cbcbcb',
  /** '#FFFFFF' */
  white: '#FFFFFF',
  /** '#31577A' */
  primary2: '#31577A',
  /** '#e61e16' */
  primary: '#e61e16',
  /** '#EAEAEA' */
  whisper: '#EAEAEA',
  /** '#E61F17' */
  vividRed: '#E61F17',
  /** '#387A47' */
  darkLimeGreen: '#387A47',
  /** '#F7F7F7' */
  whiteSmoke: '#F7F7F7',
  /** '#B53636' */
  gypsyRed: '#B53636',
  /** '#585858 */
  graniteGray: '#585858',
  /** '#23BAB5 */
  planCurrentCheck: '#23BAB5',
  /** '#1362FF */
  planSelectCheck: '#1362FF',
  /** '#C6C6C6 */
  approxSilver: '#C6C6C6',
  /** '#505050 */
  matterhorn: '#505050',
};
